<template>
	<!-- 箱货信息查询 -->
	<div class="page-container-query" id="ebOrderContainer">
		<el-form :model="ebOrder" ref="ruleFormRef" class="form-panel" label-position="top"
			:validateOnRuleChange="false">
			<el-col :span="24">
				<!-- <div> -->
				<el-row class="content-panel top-radius">
					<el-col style="height:12px;">
					</el-col>
					<el-col>
						<el-row :gutter="22">

							<el-col :span="5">
								<el-form-item label="Order No:">
									<el-input size="mini" v-model="ebOrder.orderNo"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="MBL No:">
									<el-input size="mini" v-model="ebOrder.mblNo"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="HBL No:">
									<el-input size="mini" v-model="ebOrder.hblNo"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="Container No:">
									<el-input size="mini" v-model="ebOrder.containerNo"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-form-item label="Project No:">
<!--									<el-select-->
<!--										class="length_input"-->
<!--										size="mini"-->
<!--										v-model="ebOrder.transportType"-->
<!--										placeholder="请选择"-->
<!--										clearable-->
<!--										>-->
<!--										<el-option-->
<!--											v-for="item in transportTypeList"-->
<!--											:key="item.key"-->
<!--											:label="item.value"-->
<!--											:value="item.key"-->
<!--										>-->
<!--										</el-option>-->
<!--									</el-select>-->
                  <el-input size="mini" v-model="mainOrder.projectNo"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-col>

					<el-col>
						<el-row :gutter="22">

							<el-col :span="5">
								<el-form-item label="Shipper:" >
									<el-input size="mini" v-model="ebOrder.shipper" :placeholder="$t('table.pleaseEnterEnglish')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="Consignee:" >
									<el-input size="mini" v-model="ebOrder.consignee" :placeholder="$t('table.pleaseEnterEnglish')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="POL:">
								 <el-associate
									style="width: 100%"
									:columns="associate_columns_po"
									:query-method="associate_queryMethod_po"
									class="input_length"
									clearable
									:query-length="0"
									:default-first-option="true"
									label-prop="portNameEn"
									value-prop="mdPortId"
									placeholder=""
									v-model="ebOrder.polId"
									:title="ebOrder.polName"
									@change="onPolChange"
									size="mini"
									name="polName"
									case="upper"
									/>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="POD:">
									<el-associate
									style="width: 100%"
									:columns="associate_columns_po"
									:query-method="associate_queryMethod_po"
									class="input_length"
									clearable
									:query-length="0"
									:default-first-option="true"
									label-prop="portNameEn"
									value-prop="mdPortId"
									placeholder=""
									v-model="ebOrder.podId"
									:title="ebOrder.podName"
									@change="onPodChange"
									size="mini"
									name="podName"
									case="upper"
									/>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-form-item label="Order Type:">
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_bizTypeName"
                    :query-method="associate_queryMethod_bizTypeName"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    :label-prop="displayValue"
                    :value-prop="displayValue"
                    placeholder=""
                    v-model="ebOrder.bizTypeName"
                    :title="ebOrder.bizTypeName"
                    size="mini"
                    @change="changeBizType"
                  />
								</el-form-item>
							</el-col>
						</el-row>
					</el-col>

					<el-col>
						<el-row :gutter="22">

							<el-col :span="5">
								<el-form-item label="ATD From:">

									<el-date-picker v-model="mainOrder.atdFrom" align="right" type="date"
										style="width:100%;" size="mini" placeholder="" :picker-options="pickerOptions">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="ATD TO:">

									<el-date-picker v-model="mainOrder.atdTo" align="right" type="date"
										style="width:100%;" size="mini" placeholder="" :picker-options="pickerOptions">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="ATA From:">

									<el-date-picker v-model="mainOrder.ataFrom" align="right" type="date"
										style="width:100%;" size="mini" placeholder="" :picker-options="pickerOptions">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="ATA To:">

									<el-date-picker v-model="mainOrder.ataTo" align="right" type="date"
										style="width:100%;" size="mini" placeholder="" :picker-options="pickerOptions">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="4">
<!--								<el-form-item label="Project No:">-->
<!--									<el-input size="mini" v-model="mainOrder.projectNo"></el-input>-->
<!--								</el-form-item>-->
							</el-col>
						</el-row>
					</el-col>
					<el-col style="height:2px;">
					</el-col>
					<el-row style="float:right">
						<el-button type="primary" size="small" plain @click="queryForm">Search</el-button>
						<el-button type="primary" size="small" plain @click="handlerReset">Reset</el-button>
						<el-button type="primary" size="small" plain @click="handlerExcel">EXCEL</el-button>
					</el-row>
				</el-row>

				<!-- </div> -->

				<!-- 表格-start -->
				<el-row style="margin-top: 15px">
					<hot-table ref="ebOrderTableRef" :data-source="ebOrderTableDataSource"
						:settings="ebOrderTableSettings" col-settings-key="ebOrder"
                     @cellDblclick="dbClickCustBizNo">
						<hot-column :has-tip="true" data="orderNo" title="ORDER NO." width="150">
						</hot-column>
						<hot-column :has-tip="true" data="mblNo" title="MBL NO." width="150">
						</hot-column>

						<hot-column :has-tip="true" data="hblNo" title="HBL NO." width="150">
						</hot-column>

						<hot-column :has-tip="true" data="partyDescriptionSH" title="Shipper" width="150">
						</hot-column>
						<hot-column :has-tip="true" data="partyDescriptionCn" title="Consignee" width="150">
						</hot-column>
						<hot-column :has-tip="true" data="partyDescriptionNT" title="Notify" width="150">
						</hot-column>
						<hot-column :has-tip="true" data="polName" title="POL" width="150">
						</hot-column>
						<hot-column :has-tip="true" data="podName" title="POD" width="150">
						</hot-column>
						<hot-column :has-tip="true" data="sumCtnNo" title="containerNo" width="150">
						</hot-column>
						<hot-column :has-tip="true" data="etd" title="ETD" width="150" date-format="YYYY-MM-DD">
						</hot-column>
						<hot-column :has-tip="true" data="atd" title="ATD" width="150" date-format="YYYY-MM-DD">
						</hot-column>
					</hot-table>

				</el-row>
			</el-col>
			<!-- 分页start -->
			<div class="pg_div">
				<el-pagination :current-page="pageConfig.currentPage" :layout="pageConfig.layout"
					:page-size="pageConfig.pageSize" :page-sizes="pageConfig.pageSizes" :total="pageConfig.total"
					@current-change="handleCurrentChange" @size-change="handleSizeChange" />
			</div>
			<!-- 分页end -->
		<!-- 	</el-row> -->
			<!-- 表格-end -->
		</el-form>
	</div>
</template>

<script>
	import ebOrder from "@/api/ebOrder";
	import { queryCtnCargoInfos } from '@/api/overseas'
	import { queryDictRows,queryPoInfo } from '@/api/commonService'
  import mdCodeDict from "@/api/mdCodeDict";
  import {downloadExcel} from "@/utils/downloadExcel";
	export default {
		name: 'BoxInformationQuery',
		data() {
			return {
				displayValue: 'displayValueCn',
				//日期设置
				pickerOptions: {
					// disabledDate(time) {
					// 	return time.getTime() > Date.now();
					// },
					shortcuts: [{
						text: this.$t('table.today'),
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}, {
						text: this.$t('table.yesterday'),
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: this.$t('table.aWeekAgo'),
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}]
				},
				ebOrder: {
					orderNo: '',
					mblNo: '',
					hblNo: '',
					containerNo: '',
					transportType: '',
					shipper: '',
					consignee: '',
					pol: '',
					pod: '',
					OrderType: '',
					polId: '',
					polName: '',
					podId: '',
					podName: '',
				},
				mainOrder: {
					atdFrom: '',
					atdTo: '',
					ataFrom: '',
					ataTo: '',
					projectNo: '',
				},
				// 分页
				pageConfig: {
					layout: 'total, sizes, prev, pager, next, jumper',
					total: 0,
					pageSize: 50,
					pagerCount: 10,
					currentPage: 1,
					pageSizes: [50, 100, 200, 300]
				},
				// 表格校验
				ebOrderRules: {},
				// 表格数据
				ebOrderTableDataSource: [],
				// 表格设置
				ebOrderTableSettings: {
					height: 360,
					stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
					...this.$systemConfig.tableConfig

				},
				transportTypeList: [],
				OrderTypeList: [],
				// 装/卸货港联想控件
      associate_columns_po: [
        {
          title: this.$t("associate.portNameEn"),
          field: "portNameEn",
        },
        {
          title: this.$t("associate.portNameCn"),
          field: "portNameCn",
        },
        {
          title: this.$t("associate.countryCode"),
          field: "countryCode",
        },
        {
          title: this.$t("associate.portCode"),
          field: "portCode",
        },
      ],
        //业务要素联想控件
        associate_columns_bizTypeName: [
          {
            title: this.$t("associate.typeOfService"),
            field: "displayValueCn",
          },
          {
            title: this.$t("associate.codeValue"),
            field: "codeValue",
          },
        ],
			};
		},
    async created() {

    },
		mounted() {
			let self = this
			 if(this.$cookies.get('language')==='en'){
				 this.displayValue= 'displayValueEn'
				this.associate_columns_bizTypeName=[
				{
					title: this.$t("associate.typeOfService"),
					field: "displayValueEn",
				},
				{
					title: this.$t("associate.codeValue"),
					field: "codeValue",
				},
        ]
			 }
		    this.ebOrderTableSettings.height = document.body.clientHeight - 380
			self.getSelectList()
			self.pageID = document.getElementById('ebOrderContainer')
            this.$tableAdaptation.tableAdaptation(self.pageID,self.ebOrderTableSettings)
			// 监听外层容器div宽度的变化，做表格自适应
			self.resizeObserver = new ResizeObserver(entries => {
				self.$nextTick(() => {
					self.$refs.ebOrderTableRef.resizeTo(entries[0].target.clientWidth - 32)
				})
			})
			self.resizeObserver.observe(document.getElementById("ebOrderContainer"))
		},
		methods: {
				// currentPage 改变时会触发
				handleCurrentChange(val) {
					console.log(`当前页: ${val}`)
					this.pageConfig.currentPage = val
					let self = this;
				    self.queryForm()
				},
				// pageSize 改变时会触发
				handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageConfig.pageSize = val;
				let self = this;
				self.queryForm()
			/* 	self.queryStatusPage(this.pageConfig.currentPage); */
				},
			//点击
			clickModule(e) {

			},
			queryForm(){
        let userInfo=JSON.parse(localStorage.getItem('userInfo'))
        var custId = userInfo.custId;
				var data = {
          overseaAgentId: custId,
					page: this.pageConfig.currentPage,
					pageSize: this.pageConfig.pageSize,
					orderNo: this.ebOrder.orderNo,
					mblNo: this.ebOrder.mblNo,
					hblNo: this.ebOrder.hblNo,
					sumCtnNo: this.ebOrder.containerNo,
					bizTypeCode: this.ebOrder.OrderType,
					// partyTypeSH: 'SH',
					partyDescriptionSH: this.ebOrder.shipper,
					// partyTypeCN: 'CN',
					partyDescriptionCN: this.ebOrder.consignee,
					polId: this.ebOrder.polId,
					podId: this.ebOrder.podId,
					// orderType: this.ebOrder.OrderType,
					atdStart: this.mainOrder.atdFrom,
					atdEnd: this.mainOrder.atdTo,
					ataStart: this.mainOrder.ataFrom,
					ataEnd: this.mainOrder.ataTo,
					projectNo: this.mainOrder.projectNo,
				}
				var queryData = {}
				for(let i in data){
					if(data[i]){
						queryData[i]=data[i]
					}
				}
				 if(queryData.partyDescriptionSH){
					 queryData.partyDescriptionSH="%"+this.ebOrder.shipper+"%"
           queryData.partyTypeSH = "SH"
				 }
				 if(queryData.partyDescriptionCN){
					 queryData.partyDescriptionCN="%"+this.ebOrder.consignee+"%"
           queryData.partyTypeCN = "CN"
				 }
        if(queryData.mblNo){
          queryData.mblNo="%"+this.ebOrder.mblNo+"%"
        }
        if(queryData.hblNo){
          queryData.hblNo="%"+this.ebOrder.hblNo+"%"
        }
        if(queryData.sumCtnNo){
          queryData.sumCtnNo="%"+this.ebOrder.sumCtnNo+"%"
        }
        if(queryData.orderNo){
          queryData.orderNo="%"+this.ebOrder.orderNo+"%"
        }
        if(queryData.overseaAgentId){
          queryCtnCargoInfos(queryData).then( result => {
            console.log(result)
            this.pageConfig.total = result.records.totalRecord;
            this.ebOrderTableDataSource = result.records.records
          })
        }else{
          this.$coreMethods.message(
            "warning",this.$t('message.noMerchantFound'));
        }
			},
			handlerReset(){
				this.ebOrder = {
					orderNo: '',
					mblNo: '',
					hblNo: '',
					containerNo: '',
					transportType: '',
					shipper: '',
					consignee: '',
					pol: '',
					pod: '',
					OrderType: '',
					polId: '',
					polName: '',
					podId: '',
					podName: '',
				}
				this.mainOrder = {
          atdFrom: '',
          atdTo: '',
          ataFrom: '',
          ataTo: '',
          projectNo: '',
        }
			},
			getSelectList(){
				let self = this;
				queryDictRows(
					"MD_CODE_DICT$EB_TRANSPORT_TYPE,MD_CODE_DICT$EB_LCL_ORDER_TYPE"
				).then((res) => {
					/*name:value value:key*/
					console.log("queryDictRows:", res);
					//付款方式
					self.transportTypeList = res.MD_CODE_DICT$EB_TRANSPORT_TYPE;
					//运输条款 Transport Type Order Type
					self.OrderTypeList = res.MD_CODE_DICT$EB_LCL_ORDER_TYPE;
				});
			},
      handlerExcel() {
        var self = this
        var  selectData = []
        if(this.$refs.ebOrderTableRef.getSelections().length>0){
          selectData = this.$refs.ebOrderTableRef.getSelections()
        }else{
          if(self.ebOrderTableDataSource.length>0){
            selectData = self.ebOrderTableDataSource
          }
        }
        var  overseaOrderIds = []
        for(var a in selectData){
          overseaOrderIds.push(selectData[a].goOrderId)
        }
        var tableCol =this.$refs.ebOrderTableRef.$children
        var str =''
        for(var i=0; i<tableCol.length-2; i++){
          str+= tableCol[i].columnSettings.data
          if(i!==tableCol.length-3){
            str+=','
          }
        }
        var url = window.location.origin+'/api/cts-order-service/daoService/excelExport/custom-sql/cts-manager/queryCtnCargoInfos/order'
        let reqArgs = {
          goOrderIds: overseaOrderIds
        }
        if(overseaOrderIds.length>0){
          downloadExcel(reqArgs,str,url,'Ctn&Cargo')
        }else{
          self.$coreMethods.message('warn',this.$t('message.unableToExport'))
        }
      },
			    // 装/卸货港联想控件数据源
			associate_queryMethod_po({keyword, pageSize, currentPage}) {
			let params = {};
			if (keyword === "") {
				params = {
				portType4: ["OP", "IP"],
				isDeleted5: "0",
				};
			} else {
				params = {
				portNameEn0: "%" + keyword + "%",
				portNameCn1: "%" + keyword + "%",
				countryCode2: "%" + keyword + "%",
				portCode3: "%" + keyword + "%",
				portType4: ["OP", "IP"],
				isDeleted5: "0",
				};
			}

			let data = {
				action: "query",
				crudType: "SELECT",
				sorting: ["CTS_ILPMdPort.portNameEn"],
				mainModelName: "CTS_ILPMdPort",
				tag: "CTS_ILP_es",
				where:
				"(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
				currentPage: currentPage,
				pageSize: pageSize,
				returnPage: true,
				returnTotal: false,
				reqArgs: params,
				fields: [
				"CTS_ILPMdPort.mdPortId",
				"CTS_ILPMdPort.createOffice",
				"CTS_ILPMdPort.lastModifyOffice",
				"CTS_ILPMdPort.lastModifyOfficeName",
				"CTS_ILPMdPort.lastModifierId",
				"CTS_ILPMdPort.areaCode",
				"CTS_ILPMdPort.lineNameCn",
				"CTS_ILPMdPort.portNameEn",
				"CTS_ILPMdPort.principalGroupCode",
				"CTS_ILPMdPort.customsCode",
				"CTS_ILPMdPort.isActive",
				"CTS_ILPMdPort.createOfficeName",
				"CTS_ILPMdPort.creatorName",
				"CTS_ILPMdPort.lastModifierName",
				"CTS_ILPMdPort.appCode",
				"CTS_ILPMdPort.longitude",
				"CTS_ILPMdPort.creatorId",
				"CTS_ILPMdPort.recordVersion",
				"CTS_ILPMdPort.lastModifyTime",
				"CTS_ILPMdPort.portNameCn",
				"CTS_ILPMdPort.portCode",
				"CTS_ILPMdPort.createTime",
				"CTS_ILPMdPort.isDeleted",
				"CTS_ILPMdPort.iataCode",
				"CTS_ILPMdPort.latitude",
				"CTS_ILPMdPort.lineId",
				"CTS_ILPMdPort.countryName",
				"CTS_ILPMdPort.countryCode",
				"CTS_ILPMdPort.portType",
				],
				enableCascade: true,
			};
			return new Promise((resolve) => {
				queryPoInfo(data).then((res) => {
				console.log("res", res);
				resolve({
					records: res.data.data,
					total: parseInt(res.data.totalRecord),
				});
				});
			}).catch((err) => {
				console.log(err);
			});
			},
			onPolChange(value, selectedRows) {
			this.searchData.polId = selectedRows.mdPortId;
			this.searchData.polName = selectedRows.portNameEn;
			},
			onPodChange(value, selectedRows) {
			this.searchData.podId = selectedRows.mdPortId;
			this.searchData.podName = selectedRows.portNameEn;
      },
      changeBizType(value, selectedRows) {
        this.ebOrder.OrderType = selectedRows.codeValue;
      },
      dbClickCustBizNo(val) {
        let self = this;
        let row = val.record;
        // sessionStorage.setItem("ebOrderParams", JSON.stringify([row]));
        // sessionStorage.setItem("ebOrderType", "edit");
        self.$router.push({
          path: "/overseas-agency/BoxInformationDetail",
          query: {
            type: "edit",
            goOrderId: row.goOrderId,
          },
        });
      },
      //业务类型数据服务
      associate_queryMethod_bizTypeName({keyword, pageSize, currentPage}) {
        let self = this;

        let whereParams = "";

        if (keyword === "") {
          whereParams = mdCodeDict.codeType
            .eq$("EB_MD_BUSSINESS_TYPE")
            .and(mdCodeDict.isActive.eq$(1))
            .and(mdCodeDict.isDeleted.eq$(0));
        } else {
          whereParams = mdCodeDict.codeValue
            .like$("%" + keyword + "%")
            .or(mdCodeDict.displayValueCn.like$("%" + keyword + "%"))
            .and(mdCodeDict.isActive.eq$(1))
            .and(mdCodeDict.isDeleted.eq$(0))
            .and(mdCodeDict.codeType.eq$("EB_MD_BUSSINESS_TYPE"));
        }
        let params = {
          whereObj: whereParams,
          page: currentPage,
          limit: pageSize,
        };
        return new Promise((resolve) => {
          mdCodeDict
            .queryMdCodeDict(params)
            .then((res) => {
              if (res.success) {
                resolve({
                  records: res.data.data,
                  total: res.data.totalRecord,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        });
      },
		}
	};
</script>

<style scoped lang="scss">
.page-container-query{
 height: unset !important;
}
</style>
